import { render, staticRenderFns } from "./Contact-Person.vue?vue&type=template&id=557b5e54&scoped=true"
import script from "./Contact-Person.vue?vue&type=script&lang=js"
export * from "./Contact-Person.vue?vue&type=script&lang=js"
import style0 from "./Contact-Person.vue?vue&type=style&index=0&id=557b5e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557b5e54",
  null
  
)

export default component.exports